
const IssueResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
		"gdsRefrenceID": "string",
		"provider": 0,
		"providerName": "string"
	
};
 

  export default IssueResponse;
  